<template>
  <div>
    <MasterLayout>
      <section class="mt-3 full__row_section">
        <div class="row">
          <div class="col-md-12">
            <div
              class="dashboard__card large_card card_padding indus_back_img_lg"
            >
              <div
                class="row make-row-hundred-percent align-items-center justify-content-center"
              >
                <div class="col-md-1">
                  <div
                    class="icon_wrapper yellow centralize icon_div_big"
                    style=""
                  >
                    <img src="@/assets/img/oil-truck.svg" width="" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="">
                    <h4 class="text-white mobile_text">
                      {{ $t("text.iReport.dailyReport") }}
                    </h4>
                  </div>
                  <div class="mt-5">
                    <h5 class="text-white mt-1">
                      {{ $t("text.iReport.getReport") }}
                    </h5>
                  </div>
                </div>
                <div class="col-md-4 date_picker_m">
                  <div class="">
                    <vue-ctk-date-time-picker
                      v-model="dateRange"
                      :max-date="maxDate"
                      :range="true"
                      :autoClose="true"
                      :locale="this.$root.$i18n.locale"
                      :custom-shortcuts="customShortcuts"
                      color="#370F70"
                      format="DDMMYYYY"
                      formatted="DD/MM/YYYY"
                      :label="$t('text.calendar.dateRange')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="mt-3 full__row_section pb-4">
        <div class="row">
          <div class="col-md-4">
            <div class="dashboard__card large_card">
              <div class="small__card_content_wrapper">
                <h4 class="dashboard__card__header">
                  {{ $t("text.iReport.totalHoursOnPowerGrid") }}
                </h4>
                <div class="car_content_flex_wrapper mt-3">
                  <img src="@/assets/img/042-electric_tower.svg" width="40px" />
                </div>
                <div class="mt-3" v-if="!showLoader">
                  <h3 class="dashboard__card__header_bottom">
                    {{ totalPgHours }}
                  </h3>
                </div>
                <pulse-loader
                  size="15px"
                  v-if="showLoader"
                  class="mt-2"
                ></pulse-loader>
              </div>
            </div>
          </div>
          <div
            class="col-md-4 padding_div_1 remove-padding-left"
            ref="padding_div"
          >
            <div class="dashboard__card large_card">
              <div class="small__card_content_wrapper">
                <h4 class="dashboard__card__header">
                  {{ $t("text.iReport.totalHoursOnGenGrid") }}
                </h4>
                <div class="car_content_flex_wrapper mt-3">
                  <img src="@/assets/img/002-energy.svg" width="40px" />
                </div>
                <div class="mt-3" v-if="!showLoader">
                  <h3 class="dashboard__card__header_bottom">
                    {{ totalGenHours }}
                  </h3>
                </div>
                <pulse-loader
                  size="15px"
                  v-if="showLoader"
                  class="mt-2"
                ></pulse-loader>
              </div>
            </div>
          </div>
          <div
            class="col-md-4 remove-padding-left padding_div"
            ref="padding_div"
          >
            <div
              class="dashboard__card large_card card_padding indus_back_img_lg"
            >
              <div class="row align-items-center larg_inner__row">
                <div class="col-md-4 larg_inner__row_left">
                  <img src="@/assets/svg/fuelConsumption.svg" width="90" />
                </div>
                <div class="col-md-8 larg_inner__row_right">
                  <div class="text-center">
                    <h6 class="text-white">
                      {{ $t("text.iReport.totalFuelConsumption") }}
                    </h6>
                  </div>
                  <h5 class="text-white mt-5 text-center" v-if="!showLoader">
                    {{ totalVolumeSold }} {{ $t("text.iReport.litres") }}
                  </h5>
                  <div class="d-flex flex-row-reverse mr-5 mt-4">
                    <pulse-loader
                      size="15px"
                      v-if="showLoader"
                      class="mt-2"
                    ></pulse-loader>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="mt-3 full__row_section">
        <!-- LOADER -->
        <div
          class="showLoaderDiv charts__loader w-full mt-5 mx-auto"
          style="width: 100%; height: 100%"
          v-if="showLoader"
        >
          <div :class="showLoader ? 'loading' : null"></div>
        </div>

        <div
          class="row top_section_row"
          style="border-radius: 20px"
          v-if="!showLoader"
        >
          <div class="col-md-8" v-if="!showLoader">
            <span class="date_info_span"
              >{{ $t("text.iReport.consumptionBetween") }}
              {{ $d(new Date(startDate), "short", this.$root.$i18n.locale) }}
              {{ $t("text.and.text") }}
              {{
                $d(new Date(endDate), "short", this.$root.$i18n.locale)
              }}</span
            >
            <span></span>
          </div>
          <div class="col-md-4 text-right"></div>
        </div>
        <div class="row mt-3" v-if="!showLoader">
          <div class="col-md-4">
            <div class="column_chart_wrapper m-charts" style="height: 419px">
              <apexchart
                type="donut"
                :options="chartOptions"
                :series="donutSeries"
                class="pt-5"
              ></apexchart>
            </div>
          </div>
          <div
            class="col-md-8 remove-padding-left padding_div"
            ref="padding_div"
          >
            <div class="column_chart_wrapper m_highcharts">
              <highcharts
                :options="dailyUsageChart"
                class="highchart_padding"
              ></highcharts>
            </div>
          </div>
        </div>
      </section>
      <div class="new_row_section mt-3">
        <ejs-grid
          ref="dataGrid"
          v-show="!showLoader"
          :created="refreshGrid"
          :allowPaging="true"
          :allowSorting="true"
          :pageSettings="tableProps.pageSettings"
          :toolbar="tableProps.toolbar"
          :searchSettings="tableProps.search"
          :allowExcelExport="true"
          :allowPdfExport="true"
          :toolbarClick="toolbarClick"
          :dataSource="tableProps.tableData"
          :locale="usedLang"
          v-cloak
        >
          <e-columns>
            <e-column width="80" field="index" headerText="#"></e-column>
            <e-column
              width="200"
              field="date"
              :headerText="$t('text.calendar.date')"
            ></e-column>
            <e-column
              width="250"
              field="source"
              :headerText="$t('text.iEvents.source')"
            ></e-column>
            <e-column
              width="200"
              field="usageTime"
              :headerText="$t('text.iEvents.usageTime')"
            ></e-column>
            <!-- <e-column width="200" field="hourz" headerText="Hours"></e-column> -->
            <e-column
              width="150"
              field="volume"
              :headerText="$t('text.form.volume')"
            ></e-column>
            <!-- <e-column
              width="150"
              field="volumeSold"
              :headerText="$t('text.iTankTransactions.volumeUsed')"
            ></e-column> -->
            <!-- <e-column
                  :template="tanksTemplate"
                  headerText="Action"
                  width="250"
                ></e-column> -->
          </e-columns>
        </ejs-grid>
        <!-- <TableLoader :showLoader="showLoader" /> -->
      </div>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Industrial/MasterLayout.vue";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import { Chart } from "highcharts-vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import backImg from "@/assets/img/pattern_img.png";
import { VueApexCharts } from "apexcharts";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Reports:: Epump Industrial Portal",
  name: "DashboardHome",
  components: {
    MasterLayout,
    Highcharts: Chart,
    VueApexCharts,
    VueperSlides,
    VueperSlide,
    PulseLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      showLoader: true,
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      totalPgHours: 0,
      totalGenHours: 0,
      totalVolumeSold: 0,
      nextService: "",
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      tableProps: {
        pageSettings: { pageSizes: [50, 100, 200], pageCount: 4, pageSize: 50 },
        toolbar: ["ExcelExport", "PdfExport", "Search"],
        search: { operator: "contains", ignoreCase: true },
      },
      dateRange: {
        start: this.$moment().subtract(7, "days").format("D-M-YYYY"),
        end: this.$moment().format("D-M-YYYY"),
      },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      donutSeries: [0, 0],
      backImg,
      chartOptions: {
        chart: {
          type: "donut",
          height: "470px",
        },
        title: {
          text: this.$t("text.iReport.powerDistribution"),
          align: "center",
          margin: 30,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "15px",
            fontWeight: "400",
          },
        },
        labels: [
          this.$t("text.iReport.generator"),
          this.$t("text.iReport.powerGrid"),
        ],
        donutSeries: [],
        backImg,
        chartOptions: {
          chart: {
            type: "donut",
            height: "470px",
          },
          title: {
            text: this.$t("text.iReport.powerDistribution"),
            align: "center",
            margin: 30,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize: "15px",
              fontWeight: "400",
            },
          },
          labels: [
            this.$t("text.iReport.generator"),
            this.$t("text.iReport.powerGrid"),
          ],
          colors: ["#FCD462", "#370F70"],
          legend: {
            position: "bottom",
            onItemClick: {
              toggleDataSeries: true,
            },
            fontSize: "12px",
            fontWeight: 600,
            itemMargin: {
              horizontal: 15,
            },
          },
          responsive: [
            {
              options: {
                legend: {
                  position: "bottom",
                  onItemClick: {
                    toggleDataSeries: true,
                  },
                },
              },
            },
          ],
        },
        responsive: [
          {
            options: {
              legend: {
                position: "bottom",
                onItemClick: {
                  toggleDataSeries: true,
                },
              },
            },
          },
        ],
      },
      dailyUsageChart: {
        chart: {
          type: "column",
        },
        title: {
          text: this.$t("text.iReport.dailyUsageChart"),
        },
        xAxis: {
          categories: [],
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t("text.iReport.dailyUsageHours"),
          },
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [],
      },

      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search"],
      search: { operator: "contains", ignoreCase: true },
      industryBranch: null,
      // industryBranchId: null,
    };
  },
  watch: {
    industryBranch(industryBranch) {
      if (industryBranch !== null) {
        // this.industryBranchId = newIndustry.id;
        this.getPowerUseDailyUsage();
        this.getPowerUseDetails();
        this.getTankSales();
      }
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.getPowerUseDailyUsage();
        this.getPowerUseDetails();
        this.getTankSales();
      }
    },
  },
  created() {
    this.$eventHub.$on("industryBranch", (industryBranch) => {
      this.industryBranch = industryBranch;
      document.title = `Industry Dashboard - ${industryBranch.name}`;
    });
  },
  mounted() {
    if (screen.width <= 575) {
      document
        .querySelector(".padding_div")
        .classList.remove("remove-padding-left");
      this.$refs.padding_div.classList.remove("remove-padding-left");

      document
        .querySelector(".padding_div_1")
        .classList.remove("remove-padding-left");
    }
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
    this.getPowerUseDailyUsage();
    this.getPowerUseDetails();
    this.getTankSales();
    // this.getServiceDay();
  },
  methods: {
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            filetankName: "dailyUse.pdf",
          };
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    //  getServiceDay(){
    //      this.axios
    //     .get(
    //     `${configObject.apiBaseUrl}/Industrial/NextServiceDay/${this.industryBranch.id}`,
    //       configObject.authConfig()
    //     ).
    //       then(res => {
    //            this.nextService = res.data;
    //            console.log(res.data.expectedDays)
    //       }).catch(err =>{
    //           console.log(err.message)
    //       })
    //  },
    getTankSales() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/TotalTankSales/${this.industryBranch.id}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          // const totalVolumeSold = res.data.reduce((acc, cur) => {
          //   return (acc += cur.volumeSold);
          // }, 0);
          // this.totalVolumeSold = this.convertThousand(totalVolumeSold);
          this.totalVolumeSold = this.convertThousand(
            res.data.totalVolumeConsumed
          );
        })
        .catch((error) => {});
    },
    getPowerUseDetails() {
      // console.log(this.industryBranch.id);
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/PowerUse/${this.industryBranch.id}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          let genArr = [];
          let pgArr = [];

          res.data.forEach((el, i) => {
            if (el.source === "Power Grid") {
              this.totalPgHours = el.usageTime;
              pgArr.push(el);
            } else if (el.source === "Generator") {
              genArr.push(el);
              this.totalGenHours = el.usageTime;
            }
          });
          const totalPgHours = pgArr.reduce((acc, cur) => {
            return acc + cur.hours;
          }, 0);
          const totalGenHours = genArr.reduce((acc, cur) => {
            return acc + cur.hours;
          }, 0);

          // this.totalPgHours = totalPgHours
          //   .toFixed(2)
          //   .toString()
          //   .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          // this.totalGenHours = totalGenHours
          //   .toFixed(2)
          //   .toString()
          //   .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

          const totalHours = totalPgHours + totalGenHours;
          let genPercent = (totalGenHours / totalHours) * 100;
          let powerGridPercent = (totalPgHours / totalHours) * 100;
          let gen = Number(genPercent).toFixed(2);
          let powe = Number(powerGridPercent).toFixed(2);

          this.donutSeries = [Number(gen), Number(powe)];
          // console.log(donutSeries)
        })
        .catch((error) => {});
    },
    getPowerUseDailyUsage() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/PowerUseDaily/${
            this.industryBranch.id ? this.industryBranch.id : ""
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          let index = 0;
          res.data.forEach((x) => {
            let date = new Date(x.date);
            const newDate = this.$moment(date).format("MMMM D");
            x.date = newDate;
            x.index = ++index;
            if (x.volume == null) {
              x.volume = this.$t("text.general.na");
            } else {
              x.volume = this.convertThousand(x.volume);
            }
            // element.date = new Date(element.date).toDateString();
            x.hourz = `${x.hours.toFixed(2)} ${this.$t(
              "text.iDashboard.hours"
            )} `;
          });
          let gen = res.data.filter((el) => el.source === "Generator");
          let powerGrid = res.data.filter((el) => el.source === "Power Grid");
          let genArr = [];
          let powerArr = [];
          let cats = [];

          gen.forEach((el) => {
            const newArr = el.hours.toFixed(2);
            // console.log(newArr);
            genArr.push(parseFloat(newArr));
            cats.push(el.date);
          });
          let genSeries = [
            {
              name: this.$t("text.iReport.generator"),
              data: genArr,
              color: "#FCD462",
            },
          ];
          powerGrid.forEach((el) => {
            const newArrs = el.hours.toFixed(2);
            // console.log(newArrs);
            powerArr.push(parseFloat(newArrs));
          });
          // console.log(powerArr);
          let powerSeries = [
            {
              name: this.$t("text.iReport.powerGrid"),
              data: powerArr,
              color: "#370F70",
            },
          ];

          this.dailyUsageChart.series = [...genSeries, ...powerSeries];
          this.dailyUsageChart.xAxis.categories = cats;
          this.showLoader = false;

          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: res.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {});
    },
    refreshGrid() {
      if (this.$refs.dataGrid) {
        this.$refs.dataGrid.refresh();
      }
    },
  },
};
</script>
